import React from "react";
import Image from "@root/components/image";
import addImageDimensions from "@root/utils/addImageDimensions";

const ReviewCard = ({ authorName, authorLocation, reviewMessage, image, authorImage, className = "" }) => {
    if (!authorName || !authorLocation || !reviewMessage || !image) {
        return null;
    }

    return (
        <div className={`review-card ${className}`}>
            {image && (
                <div className="review-card__image">
                    <Image
                        image={addImageDimensions(image, 400)}
                        alt={`Review by ${authorName}`}
                    />
                </div>
            )}
            <div className="review-card__content">
                <p className="review-card__message">{reviewMessage}</p>
                <div className="review-card__author">
                    {authorImage && (
                        <div className="review-card__author-avatar">
                            <Image
                                image={addImageDimensions(authorImage, 200)}
                                alt={authorName}
                                className="review-card__author-avatar-img"
                            />
                        </div>
                    )}
                    <div className="review-card__author-info">
                        <p className="review-card__author-name">{authorName}</p>
                        <p className="review-card__author-location">{authorLocation}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReviewCard;
